import { tv } from "../../variants/tv.js";
const arrowSVGVariants = tv({
    slots: {
        root: 'h-[10px] w-[20px] fill-none',
        path1: 'fill-[canvas]',
        path2: 'fill-neutral-4 dark:fill-none',
        path3: 'dark:fill-neutral-6'
    }
});
export { arrowSVGVariants };
